import { IconFusionRegular, IconMobileDeviceRegular, IconRouterRegular } from '@telefonica/mistica';

export const PRODUCT_ICONS = {
    fiber: <IconRouterRegular size={24} />,
    mobile: <IconMobileDeviceRegular size={24} />,
    bundle: <IconFusionRegular size={24} />,
} as const;
